import { ServiceCategory, ServiceItem } from "orderme-api-integration-client";
import { IsSewingCompany } from "./clientConfigs";

export const isGoodsCategory = (category: ServiceCategory) => {
    return category.itemsOnly;
}

export const isSewingService = (service: ServiceItem) => {
    return IsSewingCompany;
}

export const isLaundryService = (service: ServiceItem) => {
    return !IsSewingCompany;
}